import { forwardRef, memo } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const LandingPageCTA = memo(
  forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12717"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12717)">
          <rect
            x="-3"
            y="-2"
            width="120"
            height="114"
            rx="5.51613"
            fill="#FFEDBF"
          />
          <path
            d="M91.9805 34.8578V85.1781C91.9805 86.8463 91.3178 88.4462 90.1382 89.6258C88.9586 90.8054 87.3587 91.4681 85.6904 91.4681H25.9351C24.2668 91.4681 22.6669 90.8054 21.4873 89.6258C20.3077 88.4462 19.645 86.8463 19.645 85.1781V34.8578H91.9805Z"
            fill="#66E1FF"
          />
          <path
            d="M19.677 34.8578V85.1781C19.677 86.8463 20.3397 88.4462 21.5193 89.6258C22.6989 90.8054 24.2988 91.4681 25.967 91.4681H29.1121L85.7224 34.8578H19.677Z"
            fill="#C2F3FF"
          />
          <path
            d="M92.0125 34.8577H19.677V25.4226C19.677 23.7544 20.3397 22.1545 21.5193 20.9749C22.6989 19.7953 24.2988 19.1326 25.967 19.1326H85.7224C87.3906 19.1326 88.9905 19.7953 90.1702 20.9749C91.3498 22.1545 92.0125 23.7544 92.0125 25.4226V34.8577Z"
            fill="white"
          />
          <path
            d="M85.7224 19.1326H25.967C24.2988 19.1326 22.6989 19.7953 21.5193 20.9749C20.3397 22.1545 19.677 23.7544 19.677 25.4226V85.178C19.677 86.8462 20.3397 88.4461 21.5193 89.6257C22.6989 90.8053 24.2988 91.468 25.967 91.468H85.7224C87.3906 91.468 88.9905 90.8053 90.1702 89.6257C91.3498 88.4461 92.0125 86.8462 92.0125 85.178V25.4226C92.0125 23.7544 91.3498 22.1545 90.1702 20.9749C88.9905 19.7953 87.3906 19.1326 85.7224 19.1326Z"
            stroke="#191919"
            strokeWidth="1.03427"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.677 34.8578H92.0125"
            stroke="#191919"
            strokeWidth="1.03427"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M30.6844 27.7814C30.4759 27.7814 30.2759 27.6985 30.1285 27.5511C29.981 27.4036 29.8982 27.2036 29.8982 26.9951C29.8982 26.7866 29.981 26.5866 30.1285 26.4392C30.2759 26.2917 30.4759 26.2089 30.6844 26.2089"
            stroke="#191919"
            strokeWidth="1.03427"
          />
          <path
            d="M30.6846 27.7814C30.8931 27.7814 31.0931 27.6985 31.2405 27.5511C31.388 27.4036 31.4708 27.2036 31.4708 26.9951C31.4708 26.7866 31.388 26.5866 31.2405 26.4392C31.0931 26.2917 30.8931 26.2089 30.6846 26.2089"
            stroke="#191919"
            strokeWidth="1.03427"
          />
          <path
            d="M81.0049 41.0464H30.6846C30.2675 41.0464 29.8675 41.2121 29.5726 41.507C29.2777 41.8019 29.1121 42.2018 29.1121 42.6189V48.9089C29.1121 49.326 29.2777 49.726 29.5726 50.0209C29.8675 50.3158 30.2675 50.4814 30.6846 50.4814H81.0049C81.4219 50.4814 81.8219 50.3158 82.1168 50.0209C82.4117 49.726 82.5774 49.326 82.5774 48.9089V42.6189C82.5774 42.2018 82.4117 41.8019 82.1168 41.507C81.8219 41.2121 81.4219 41.0464 81.0049 41.0464Z"
            fill="#FFEF5E"
          />
          <path
            d="M30.6846 41.0464C30.2675 41.0464 29.8675 41.2121 29.5726 41.507C29.2777 41.8019 29.1121 42.2018 29.1121 42.6189V48.9089C29.1121 49.326 29.2777 49.726 29.5726 50.0209C29.8675 50.3158 30.2675 50.4814 30.6846 50.4814H66.8523L76.2874 41.0464H30.6846Z"
            fill="#FFF9BF"
          />
          <path
            d="M81.0049 41.0464H30.6846C30.2675 41.0464 29.8675 41.2121 29.5726 41.507C29.2777 41.8019 29.1121 42.2018 29.1121 42.6189V48.9089C29.1121 49.326 29.2777 49.726 29.5726 50.0209C29.8675 50.3158 30.2675 50.4814 30.6846 50.4814H81.0049C81.4219 50.4814 81.8219 50.3158 82.1168 50.0209C82.4117 49.726 82.5774 49.326 82.5774 48.9089V42.6189C82.5774 42.2018 82.4117 41.8019 82.1168 41.507C81.8219 41.2121 81.4219 41.0464 81.0049 41.0464Z"
            stroke="#191919"
            strokeWidth="1.03427"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42.372 57.1676H31.0093C30.708 57.1676 30.4189 57.2873 30.2059 57.5004C29.9928 57.7135 29.873 58.0025 29.873 58.3039V67.394C29.873 67.6953 29.9928 67.9844 30.2059 68.1974C30.4189 68.4105 30.708 68.5303 31.0093 68.5303H42.372C42.6733 68.5303 42.9623 68.4105 43.1754 68.1974C43.3885 67.9844 43.5082 67.6953 43.5082 67.394V58.3039C43.5082 58.0025 43.3885 57.7135 43.1754 57.5004C42.9623 57.2873 42.6733 57.1676 42.372 57.1676Z"
            fill="#FFEF5E"
            stroke="#191919"
            strokeWidth="1.03427"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M30.2371 57.4694L43.145 68.2275"
            stroke="#191919"
            strokeWidth="1.03427"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M30.2371 68.2275L43.145 57.4694"
            stroke="#191919"
            strokeWidth="1.03427"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M51.2285 58.7911H82.6787"
            stroke="#191919"
            strokeWidth="1.03427"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M51.2285 65.0809H76.1858"
            stroke="#191919"
            strokeWidth="1.03427"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M40.1195 27.7814C39.911 27.7814 39.711 27.6985 39.5635 27.5511C39.4161 27.4036 39.3333 27.2036 39.3333 26.9951C39.3333 26.7866 39.4161 26.5866 39.5635 26.4392C39.711 26.2917 39.911 26.2089 40.1195 26.2089"
            stroke="#191919"
            strokeWidth="1.03427"
          />
          <path
            d="M40.1196 27.7814C40.3282 27.7814 40.5281 27.6985 40.6756 27.5511C40.823 27.4036 40.9059 27.2036 40.9059 26.9951C40.9059 26.7866 40.823 26.5866 40.6756 26.4392C40.5281 26.2917 40.3282 26.2089 40.1196 26.2089"
            stroke="#191919"
            strokeWidth="1.03427"
          />
          <path
            d="M49.5546 27.7814C49.346 27.7814 49.1461 27.6985 48.9986 27.5511C48.8511 27.4036 48.7683 27.2036 48.7683 26.9951C48.7683 26.7866 48.8511 26.5866 48.9986 26.4392C49.1461 26.2917 49.346 26.2089 49.5546 26.2089"
            stroke="#191919"
            strokeWidth="1.03427"
          />
          <path
            d="M49.5544 27.7815C49.763 27.7815 49.963 27.6987 50.1104 27.5512C50.2579 27.4038 50.3407 27.2038 50.3407 26.9952C50.3407 26.7867 50.2579 26.5867 50.1104 26.4393C49.963 26.2918 49.763 26.209 49.5544 26.209"
            stroke="#191919"
            strokeWidth="1.03427"
          />
          <path
            d="M36.8831 74.9515C36.8831 74.1899 37.5005 73.5725 38.2621 73.5725H98.9395C99.7011 73.5725 100.319 74.1899 100.319 74.9515V86.7133C100.319 87.4749 99.7011 88.0923 98.9395 88.0923H38.2621C37.5005 88.0923 36.8831 87.4749 36.8831 86.7133V74.9515Z"
            fill="black"
          />
          <path
            d="M52.1252 81.7268H53.2928C53.274 82.0607 53.1784 82.353 53.006 82.6035C52.8336 82.854 52.5952 83.0492 52.2909 83.1893C51.9865 83.3266 51.6283 83.3953 51.2162 83.3953C50.8795 83.3953 50.5792 83.3428 50.3153 83.2378C50.054 83.1327 49.8318 82.9805 49.6486 82.7812C49.4655 82.5819 49.3254 82.3409 49.2285 82.058C49.1342 81.7752 49.0871 81.4547 49.0871 81.0965V80.8622C49.0871 80.5039 49.1369 80.1834 49.2365 79.9006C49.3362 79.6151 49.4789 79.3727 49.6648 79.1734C49.8506 78.9741 50.0728 78.8219 50.3314 78.7169C50.59 78.6091 50.8795 78.5553 51.2 78.5553C51.6364 78.5553 52.004 78.6293 52.303 78.7775C52.6047 78.9256 52.8376 79.1289 53.0019 79.3875C53.1689 79.6434 53.2672 79.9356 53.2969 80.2642H52.1333C52.1252 80.1134 52.0902 79.9787 52.0283 79.8602C51.9663 79.739 51.868 79.6434 51.7333 79.5734C51.6014 79.5033 51.4236 79.4683 51.2 79.4683C51.0438 79.4683 50.9065 79.4966 50.788 79.5532C50.6694 79.6097 50.5698 79.6959 50.489 79.8117C50.4109 79.9275 50.3516 80.073 50.3112 80.2481C50.2708 80.4204 50.2506 80.6238 50.2506 80.8581V81.0965C50.2506 81.3335 50.2681 81.5396 50.3031 81.7146C50.3408 81.8897 50.3988 82.0352 50.4769 82.151C50.555 82.2641 50.6546 82.3489 50.7758 82.4055C50.8997 82.4621 51.0465 82.4903 51.2162 82.4903C51.4101 82.4903 51.5731 82.4634 51.7051 82.4095C51.837 82.353 51.938 82.2681 52.0081 82.155C52.0781 82.0419 52.1172 81.8991 52.1252 81.7268ZM57.2158 82.4217V83.3307H54.6544V82.4217H57.2158ZM55.0665 78.6239V83.3307H53.9029V78.6239H55.0665ZM59.0015 78.6239V83.3307H57.8339V78.6239H59.0015ZM62.7831 81.7268H63.9507C63.9319 82.0607 63.8362 82.353 63.6639 82.6035C63.4915 82.854 63.2531 83.0492 62.9488 83.1893C62.6444 83.3266 62.2862 83.3953 61.8741 83.3953C61.5374 83.3953 61.2371 83.3428 60.9731 83.2378C60.7119 83.1327 60.4897 82.9805 60.3065 82.7812C60.1234 82.5819 59.9833 82.3409 59.8863 82.058C59.7921 81.7752 59.7449 81.4547 59.7449 81.0965V80.8622C59.7449 80.5039 59.7948 80.1834 59.8944 79.9006C59.9941 79.6151 60.1368 79.3727 60.3227 79.1734C60.5085 78.9741 60.7307 78.8219 60.9893 78.7169C61.2479 78.6091 61.5374 78.5553 61.8579 78.5553C62.2943 78.5553 62.6619 78.6293 62.9609 78.7775C63.2625 78.9256 63.4955 79.1289 63.6598 79.3875C63.8268 79.6434 63.9251 79.9356 63.9547 80.2642H62.7912C62.7831 80.1134 62.7481 79.9787 62.6861 79.8602C62.6242 79.739 62.5259 79.6434 62.3912 79.5734C62.2592 79.5033 62.0815 79.4683 61.8579 79.4683C61.7017 79.4683 61.5643 79.4966 61.4458 79.5532C61.3273 79.6097 61.2277 79.6959 61.1469 79.8117C61.0687 79.9275 61.0095 80.073 60.9691 80.2481C60.9287 80.4204 60.9085 80.6238 60.9085 80.8581V81.0965C60.9085 81.3335 60.926 81.5396 60.961 81.7146C60.9987 81.8897 61.0566 82.0352 61.1347 82.151C61.2128 82.2641 61.3125 82.3489 61.4337 82.4055C61.5576 82.4621 61.7044 82.4903 61.8741 82.4903C62.068 82.4903 62.231 82.4634 62.3629 82.4095C62.4949 82.353 62.5959 82.2681 62.6659 82.155C62.736 82.0419 62.775 81.8991 62.7831 81.7268ZM65.7243 78.6239V83.3307H64.5608V78.6239H65.7243ZM68.7221 78.6239L66.7788 81.0319L65.6758 82.1146L65.3809 81.0763L66.1283 80.0784L67.2636 78.6239H68.7221ZM67.3848 83.3307L66.0273 81.2258L66.9242 80.5672L68.7665 83.3307H67.3848ZM74.5763 80.5672V81.4763H71.9542V80.5672H74.5763ZM72.334 78.6239V83.3307H71.1704V78.6239H72.334ZM75.3681 78.6239V83.3307H74.2046V78.6239H75.3681ZM79.6305 82.4217V83.3307H76.9236V82.4217H79.6305ZM77.3357 78.6239V83.3307H76.1721V78.6239H77.3357ZM79.283 80.442V81.351H76.9236V80.442H79.283ZM79.6345 78.6239V79.537H76.9236V78.6239H79.6345ZM80.1516 78.6239H82.1192C82.4101 78.6239 82.6727 78.6549 82.907 78.7169C83.1413 78.7761 83.3407 78.865 83.505 78.9835C83.6719 79.102 83.7999 79.2502 83.8888 79.4279C83.9777 79.603 84.0221 79.8063 84.0221 80.038C84.0221 80.3127 83.9763 80.5416 83.8847 80.7248C83.7932 80.908 83.6666 81.0574 83.505 81.1733C83.3433 81.2891 83.1562 81.386 82.9434 81.4641L82.5555 81.6904H80.8829L80.8748 80.7814H82.1273C82.2889 80.7814 82.4235 80.7571 82.5313 80.7086C82.639 80.6575 82.7198 80.5847 82.7737 80.4905C82.8276 80.3962 82.8545 80.2844 82.8545 80.1551C82.8545 80.0232 82.8262 79.9114 82.7697 79.8198C82.7131 79.7282 82.6296 79.6582 82.5192 79.6097C82.4114 79.5612 82.2781 79.537 82.1192 79.537H81.3192V83.3307H80.1516V78.6239ZM82.9434 83.3307L81.8162 81.2541L83.0525 81.2419L84.1999 83.2822V83.3307H82.9434ZM88.2521 82.4217V83.3307H85.5452V82.4217H88.2521ZM85.9573 78.6239V83.3307H84.7938V78.6239H85.9573ZM87.9047 80.442V81.351H85.5452V80.442H87.9047ZM88.2562 78.6239V79.537H85.5452V78.6239H88.2562Z"
            fill="white"
          />
          <path
            d="M103.05 92.8414C103.221 93.2526 103.057 94.8098 102.148 95.1707C101.24 95.5317 100.079 95.1707 100.079 95.1707L97.9734 90.9589L94.3337 94.5985V78.1603L105.483 89.3098H101.329C101.533 89.7008 102.832 92.319 103.05 92.8414Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M95.3105 80.5184V92.2402L98.241 89.3098L100.683 94.1938C100.683 94.1938 101.344 94.4046 101.66 94.1938C101.976 93.983 102.291 93.5585 102.148 93.217C101.477 91.6049 99.7062 88.3329 99.7062 88.3329H103.125L95.3105 80.5184Z"
            fill="black"
          />
        </g>
      </SvgIcon>
    );
  })
);
LandingPageCTA.displayName = 'LandingPageCTA';
